import { get, } from '.';

export function GetLlmAssessmentItems(options = {}) {
	return get<any>("/app/api/llm_assessment_items", options);
}
